module.exports = __webpack_public_path__ + "fonts/439c5962-f9fe-4eaf-a1f6-f41d42edba75.d9dbca3.woff";